module.exports = __webpack_public_path__ + "img/盖章@3x.ddf4bf3a.png";